// src/components/Navbar.jsx
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const translations = {
  en: { home: 'Home', services: 'Blog', about: 'About', contact: 'Contact' },
  fr: { home: 'Accueil', services: 'Blog', about: 'À propos', contact: 'Contact' },
  nl: { home: 'Start', services: 'Blog', about: 'Over ons', contact: 'Contact' }
};

const Navbar = ({ language }) => {
  const t = translations[language];

  return (
    <nav className="bg-white border-b border-gray-200 fixed w-full z-10 top-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Link to="/" className="flex items-center">
            <img src={logo} alt="JRAutomation Logo" className="h-20 w-20" />
          </Link>
          <div className="hidden md:flex space-x-6">
            <Link to="/" className="text-gray-700 hover:text-blue-600">{t.home}</Link>
            <a href="#Blog" className="text-gray-700 hover:text-blue-600">{t.services}</a>
            <a href="#about" className="text-gray-700 hover:text-blue-600">{t.about}</a>
            <a href="#contact" className="text-gray-700 hover:text-blue-600">{t.contact}</a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

